import { createLucideIcon } from 'lucide-react';

const SkillsIcon = createLucideIcon('Skills', [
  [
    'path',
    {
      d: 'M15.4434 2.31193C14.545 1.80659 13.4501 1.79785 12.5438 2.28878L3.04743 7.43264C2.40205 7.78222 2 8.45724 2 9.19122V16.8303C2 17.5529 2.38972 18.2192 3.01948 18.5735L8.55657 21.6881C9.45496 22.1934 10.5499 22.2022 11.4562 21.7112L20.9526 16.5674C21.598 16.2178 22 15.5428 22 14.8088V7.1697C22 6.44715 21.6103 5.78078 20.9805 5.42654L15.4434 2.31193Z',
      key: '1',
    },
  ],
  [
    'path',
    {
      d: 'M22 6 11.456 11.711C10.55 12.202 9.455 12.193 8.557 11.688L2 8M22 11 11.456 16.711C10.55 17.202 9.455 17.193 8.557 16.688L2 13M10 12V22',
      key: '2',
    },
  ],
]);

SkillsIcon.displayName = 'SkillsIcon';

export default SkillsIcon;
